export const ASSOCIATED_ACTIVITY_QUERY = '/activity/associated';
